import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ListSearchPipe} from './list-search.pipe';

@NgModule({
  declarations: [ListSearchPipe],
  exports: [ListSearchPipe],
  imports: [
    CommonModule
  ]
})
export class ListSearchPipeModule { }
